import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * SAS (Shared Access Signature) query string for authenticating slide image/asset
 * requests. Consumed by the fabric slide renderer container; the value is provided by
 * the hosting app/feature-shell.
 */
export const SLIDE_SYNC_SAS = new InjectionToken<Observable<string>>('SLIDE_SYNC_SAS');
